<template src='./pif1-5-5.html'></template>

<script>
import Vue from 'vue'
import { EventBus } from '@/router/bus'
import ContextPage from '@/components/misc/context-page/ContextPage.vue'
import { JSONEditor } from '@json-editor/json-editor/'
import flatpickr from 'flatpickr'
import { SerbianCyrillic } from 'flatpickr/dist/l10n/sr-cyr'
import SimpleMDE from 'simplemde/dist/simplemde.min.js'
import { hasAdminClaim, hasProjectManageClaim, hasProjectEvaluateClaim, authorizedOrganizationId } from '@/router/auth'

export default {
  components: {
    ContextPage,
    flatpickr,
    SerbianCyrillic,
    SimpleMDE
  },
  data () {
    return {
      markFields: 7,
      showErrorPanel: false,
      jsonDialog: false,
      jsonScheme: null,
      validationErrors: [],
      autoCompleteUrl_budgetId: Vue.$apiConfig.budgetUsersGet,
      resultContent: null,
      initialSchema: {},
      initialEditor: {},
      initialConfig: {},
      initialVal: {},
      initialMarks: {},
      pif: null,
      errorPanel: null,
      editor: null,
      projectCode: this.$route.params.projectCode,
      projectPhaseId: this.$route.params.projectPhaseId,
      phaseFormId: this.$route.params.phaseFormId,
      formId: null,
      formStatus: 0,
      evaluator: '',
      project: {},
      projectForm: null,
      loading: false,
      ProjectStatus: {
        DRAFT: 1,
        CREATED: 2,
        ACCEPTED: 3
      },
      FormInputAction: {
        SAVE: 1,
        LOCKSAVE: 2,
        UNLOCKSAVE: 3,
        MARK: 4,
        LOCKMARK: 5,
        UNLOCKMARK: 6
      },
      FormInputStatus: {
        UNLOCKED: 1,
        LOCKED: 2,
        MARKED: 3,
        APPROVED: 4
      },
      status: [
        {
          color: 'pending',
          text: this.$t('projects.formStatuses.1')
        },
        {
          color: 'active-light',
          text: this.$t('projects.formStatuses.2')
        },
        {
          color: 'active-light',
          text: this.$t('projects.formStatuses.3')
        },
        {
          color: 'success',
          text: this.$t('projects.formStatuses.4')
        }
      ],
      flatpickrElements: [
        {
          editor: 'root.1.dates.Завршетак припреме / процене.start date',
          element: 'root[1][dates][Завршетак припреме / процене][start date]'
        },
        {
          editor: 'root.1.dates.Завршетак припреме / процене.end date',
          element: 'root[1][dates][Завршетак припреме / процене][end date]'
        },
        {
          editor: 'root.1.dates.Јавни позив за набавку.start date',
          element: 'root[1][dates][Јавни позив за набавку][start date]'
        },
        {
          editor: 'root.1.dates.Јавни позив за набавку.end date',
          element: 'root[1][dates][Јавни позив за набавку][end date]'
        },
        {
          editor: 'root.1.dates.Додељивање уговора.start date',
          element: 'root[1][dates][Додељивање уговора][start date]'
        },
        {
          editor: 'root.1.dates.Додељивање уговора.end date',
          element: 'root[1][dates][Додељивање уговора][end date]'
        },
        {
          editor: 'root.1.dates.Почетак радова.start date',
          element: 'root[1][dates][Почетак радова][start date]'
        },
        {
          editor: 'root.1.dates.Почетак радова.end date',
          element: 'root[1][dates][Почетак радова][end date]'
        },
        {
          editor: 'root.1.dates.Завршетак радова.start date',
          element: 'root[1][dates][Завршетак радова][start date]'
        },
        {
          editor: 'root.1.dates.Завршетак радова.end date',
          element: 'root[1][dates][Завршетак радова][end date]'
        },
        {
          editor: 'root.1.dates.Пројекат постаје оперативан.start date',
          element: 'root[1][dates][Пројекат постаје оперативан][start date]'
        },
        {
          editor: 'root.1.dates.Пројекат постаје оперативан.end date',
          element: 'root[1][dates][Пројекат постаје оперативан][end date]'
        },
        {
          editor: 'root.8.c2',
          element: 'root[8][c2]'
        }
      ],
      serbianLocale: {
        locale: SerbianCyrillic,
        allowInput: true,
        enableTime: false,
        dateFormat: 'd.m.Y.',
        minDate: new Date(2019, 1, 1),
        maxDate: new Date(2030, 1, 1)
      }
    }
  },
  computed: {
    isAdmin () {
      return hasAdminClaim()
    },
    canManageProject () {
      return hasProjectManageClaim()
    },
    userOrganizationId () {
      return authorizedOrganizationId()
    },
    canEditProject () {
      return this.formStatus === this.FormInputStatus.UNLOCKED && hasProjectManageClaim() && this.userOrganizationId === this.project.organizationId && Number(this.projectPhaseId) === this.project.projectPhaseId
    },
    canUnlockProject () {
      return this.formStatus === this.FormInputStatus.LOCKED && hasProjectManageClaim() && this.userOrganizationId === this.project.organizationId && Number(this.projectPhaseId) === this.project.projectPhaseId
    },
    canEvaluateProject () {
      return this.formStatus === this.FormInputStatus.LOCKED && hasProjectEvaluateClaim() && this.userOrganizationId === this.evaluator && Number(this.projectPhaseId) === this.project.projectPhaseId
    }
  },
  methods: {
    validateFormInput () {
      const errors = this.editor.validate()
      if (errors && errors.length > 0) {
        this.validationErrors = errors
        this.showErrorPanel = true
        this.$nextTick(function () {
          this.scrollToErrorPanel()
        })
      }
    },
    submitFormInput (action) {
      // if (this.validateFormInput()) { return }
      this.loading = true
      const values = this.editor.getValue()
      for (var i = 0; i < this.markFields; i++) {
        const markdownEditor = 'root.' + (i + 1) + '.comment'
        const markdownName = 'comment'
        const markName = 'mark'
        values[i + 1][markdownName] = this.editor.getEditor(markdownEditor).simplemde_instance.value()
        delete values[i + 1][markName]
      }
      this.projectForm = {
        projectCode: this.projectCode,
        projectPhaseId: this.projectPhaseId,
        id: this.phaseFormId,
        formId: this.formId,
        json: JSON.stringify(values),
        action: action
      }
      this.$http.post(Vue.$apiConfig.projectInputFormPost, this.projectForm)
        .then(
          response => {
            this.logConsole(response)
            EventBus.$emit('alert', {
              variant: 'success',
              message: this.$t('projects.submitProjectFormInputSuccessful'),
              errors: []
            })
            this.setupPage()
            this.loading = false
          },
          error => {
            this.formatErrorResponse(error)
            this.loading = false
          }
        )
    },
    markFormInput (valid) {
      this.loading = true
      const markeditors = {}
      for (let i = 0; i < this.markFields; i++) {
        markeditors[(i + 1) + '.mark'] = this.editor.getEditor('root.' + (i + 1) + '.mark').getValue()
      }
      this.projectForm = {
        projectCode: this.projectCode,
        formId: this.formId,
        json: JSON.stringify(markeditors),
        action: this.FormInputAction.MARK
      }
      this.$http.post(Vue.$apiConfig.projectInputFormPost, this.projectForm)
        .then(
          response => {
            this.logConsole(response)
            EventBus.$emit('alert', {
              variant: 'success',
              message: this.$t('projects.markProjectFormInputSuccessful'),
              errors: []
            })
            this.setupPage()
            this.loading = false
          },
          error => {
            this.formatErrorResponse(error)
            this.loading = false
          }
        )
    },
    fetch (query) {
      const queryParamName = 'search'
      const url = this.autoCompleteUrl_budgetId
      const params = Object.assign({ [queryParamName]: query })
      const cancel = new Promise((resolve) => (this.cancel = resolve))
      const request = this.$http.get(url, { params })

      return Promise.race([cancel, request])
    },
    cancel () {
      // used to 'cancel' previous searches
    },
    setupPage () {
      this.loading = true
      this.$http.get(Vue.$apiConfig.inputFormGet.replace('{projectCode}', this.$route.params.projectCode) + '/forms/' + this.phaseFormId)
        .then(
          response => {
            this.logConsole(response)
            const payload = response.data.payload
            const formInput = payload.projectFormInput
            this.formStatus = formInput.status
            this.evaluator = payload.projectForm.evaluator
            this.formId = payload.projectForm.id
            this.pif = JSON.parse(payload.projectForm.json)
            this.initialSchema = this.pif.schema
            this.initialConfig = this.pif.config
            this.initialVal = formInput.inputJson ? JSON.parse(formInput.inputJson) : null
            this.initialMarks = formInput.markJson ? JSON.parse(formInput.markJson) : null
            this.initializeEditor()
            this.loading = false
          },
          error => {
            this.formatErrorResponse(error)
            this.loading = false
          }
        )
    },
    initializeEditor () {
      const el = document.getElementById('editorHolder')
      this.initialConfig.schema = this.initialSchema
      this.initialConfig.no_additional_properties = true
      this.initialConfig.schema.definitions.question.properties.mark.options.hidden = (this.formStatus !== this.FormInputStatus.LOCKED || this.formStatus !== this.FormInputStatus.MARKED)
      if (this.canEvaluateProject) {
        this.initialConfig.disable_array_add = true
        this.initialConfig.disable_array_delete = true
        this.initialConfig.disable_array_delete_all_rows = true
        this.initialConfig.disable_array_delete_last_row = true
        this.initialConfig.disable_array_reorder = true
      }
      if (this.editor) { this.editor.destroy() }
      this.editor = new JSONEditor(el, this.initialConfig)
      this.resultContent = this.initialEditor

      this.editor.on('ready', () => {
        for (var k = 0; k < this.flatpickrElements.length; k++) {
          this.editor.getEditor(this.flatpickrElements[k].editor).flatpickr = flatpickr(document.getElementsByName(this.flatpickrElements[k].element), this.serbianLocale)
        }
        for (var j = 0; j < this.markFields; j++) {
          const markdownEditor = 'root.' + (j + 1) + '.comment'
          const markdownElement = 'root[' + (j + 1) + '][comment]'
          this.editor.getEditor(markdownEditor).simplemde_instance.toTextArea()
          this.editor.getEditor(markdownEditor).simplemde_instance = null
          const config = {
            element: document.getElementsByName(markdownElement)[0],
            spellChecker: false,
            hideIcons: ['heading'],
            autosave: { enabled: true },
            showIcons: this.canEditProject ? ['heading-2', 'heading-3', 'horizontal-rule', 'code', 'table'] : false,
            status: ['autosave', 'lines', 'words', 'cursor']
          }
          if (!this.canEditProject) { config.toolbar = false }
          this.editor.getEditor(markdownEditor).simplemde_instance = new SimpleMDE(config)
        }
        if (this.initialVal) {
          if (this.initialMarks) { Object.assign(this.initialVal, this.initialMarks) }
          this.saveJsonValues(this.initialVal)
        }
        this.manageInput()
      })
      // this.editor.element.children[0].children[2].className = 'hidden-panel'
      console.log(this.editor)
    },
    manageInput () {
      if (this.isAdmin) { return }
      if (this.canEditProject) {
        for (var i = 0; i < this.markFields; i++) {
          this.editor.getEditor('root.' + (i + 1) + '.comment')
          this.editor.getEditor('root.' + (i + 1) + '.mark').disable()
        }
      } else if (this.canEvaluateProject) {
        this.editor.disable()
        for (var j = 0; j < this.markFields; j++) {
          this.editor.getEditor('root.' + (j + 1) + '.comment').simplemde_instance.togglePreview()
          this.editor.getEditor('root.' + (j + 1) + '.mark').enable()
        }
      } else {
        this.editor.disable()
        for (i = 0; i < this.markFields; i++) {
          this.editor.getEditor('root.' + (i + 1) + '.comment').simplemde_instance.togglePreview()
          this.editor.getEditor('root.' + (i + 1) + '.mark').disable()
        }
      }
    },
    openJsonDialog () {
      this.jsonScheme = JSON.stringify(this.editor.getValue(), null, 2)
      this.jsonDialog = true
    },
    closeJsonDialog () {
      this.saveJsonValues(JSON.parse(this.jsonScheme))
      this.jsonDialog = false
    },
    saveJsonValues (jsonScheme) {
      const markName = 'mark'
      const markComment = 'comment'
      for (var i = 0; i < this.markFields; i++) {
        if (jsonScheme[i + 1] && !jsonScheme[i + 1][markName]) {
          jsonScheme[i + 1][markName] = {}
          jsonScheme[i + 1][markName][markComment] = ''
        }
      }
      for (const key in jsonScheme) {
        var property = this.editor.getEditor('root.' + key)
        if (property) {
          property.setValue('')
          property.setValue(jsonScheme[key])
        }
      }
    },
    extractErrorItem (message) {
      var regExp = /'[0-9]+'/
      return regExp.exec(message)[0]
    },
    scrollToErrorPanel () {
      const element = this.$refs.errorPanel
      var top = element.offsetTop

      window.scrollTo(0, top)
    }
  },
  created () {
    this.setupPage()
  }
}
</script>

<style>
.v-chip {
  font-weight: 600 !important;
  /* font-size: 20px !important */
}
.item-container {
  font-weight: 600 !important;
  font-size: 15px !important;
}

.drop-menu-item {
  margin: 0 0 0 50px;
}
.claim-item {
  font-size: 15px;
  font-weight: 300;
  line-height: 1;
  letter-spacing: 0.02em;
  font-family: 'Source Sans Pro', sans-serif;
  margin-left: 30px;
}

.centered-label {
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.list-container {
  height: 264px;
  overflow-y: auto;
  font-size: 11pt;
  border: 1px solid rgba(0, 0, 0, .12);
}
.autocomplete-result {
  background-image: none !important;
  padding-left: 10px !important;
}
.hidden-panel {
  display: none !important;
}

[data-schemapath*="root.1.dates.Header"] {
  line-height: 1rem !important;
}
/* [data-schemapath="root.3.sources-total"] { padding-bottom: 0px !important } */
[data-schemapath="root.1.dates"] {  padding-top: 0px !important }
[data-schemapath*="root.1.dates."] {
  line-height: .2rem;
  padding-bottom: 0px !important;
  padding-top: 0px !important;
}
[data-schemapath*="root.1.dates"] .je-panel { padding: 0px !important;}
[data-schemapath*="root.1.dates"] .je-panel .container {
  padding: 0px 12px !important;
}

</style>
